import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { Box as d, AppBar as g, Toolbar as p, IconButton as u, Typography as k, Menu as C, MenuItem as M, ListItemIcon as w, ListItemText as I } from "@mui/material";
import T from "@mui/icons-material/ArrowBack";
import j from "@mui/icons-material/Menu";
import { useState as A } from "react";
const O = ({ title: t, onBackButtonClick: l, children: o, menuItems: i, position: r = "fixed", parentToolbar: a, onMenuItemClick: n, ...x }) => {
  const [s, h] = A(null), b = !!s, m = (y) => {
    h(y.currentTarget);
  }, f = () => {
    h(null);
  };
  return /* @__PURE__ */ c(d, { children: [
    /* @__PURE__ */ c(g, { position: r, ...x, children: [
      a,
      /* @__PURE__ */ c(p, { sx: { justifyContent: "space-between" }, children: [
        /* @__PURE__ */ e(d, { sx: { width: "40px" }, children: l && /* @__PURE__ */ e(u, { color: "inherit", "aria-label": "go back", onClick: l, children: /* @__PURE__ */ e(T, {}) }) }),
        /* @__PURE__ */ e(k, { variant: "h6", component: "div", sx: { display: "flex", alignItems: "center" }, children: o || t }),
        /* @__PURE__ */ e(d, { sx: { width: "40px" }, children: i && /* @__PURE__ */ e(u, { color: "inherit", "aria-label": "open menu", onClick: m, children: /* @__PURE__ */ e(j, {}) }) })
      ] })
    ] }),
    (r === "sticky" || r === "fixed") && /* @__PURE__ */ e(p, {}),
    i && /* @__PURE__ */ e(B, { menuItems: i, anchorEl: s, open: b, onClose: f, onMenuItemClick: n })
  ] });
}, B = ({ anchorEl: t, open: l, onClose: o, menuItems: i, onMenuItemClick: r }) => {
  const a = (n) => {
    r && r(n), o();
  };
  return /* @__PURE__ */ e(
    C,
    {
      id: "basic-menu",
      anchorEl: t,
      open: l,
      onClose: o,
      MenuListProps: {
        "aria-labelledby": "basic-button"
      },
      children: i.map((n) => /* @__PURE__ */ c(M, { onClick: () => a(n), children: [
        n.icon && /* @__PURE__ */ e(w, { children: n.icon }),
        /* @__PURE__ */ e(I, { children: n.label })
      ] }, n.key))
    }
  );
};
export {
  O as PageHeader,
  B as PageHeaderMenu
};
//# sourceMappingURL=index.js.map
